'use client'

import React from 'react'
import { UserX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState } from '@kiao-voice/ui-kit'

interface DisabledWorkspaceNoticeProps {
  /** 使用者選擇離開這個 workspace（切到個人）。 */
  onSwitchWorkspace: () => void
  /** 只重新讀取權限，不改成員狀態或席位。 */
  onRecheck: () => void
}

/**
 * 成員在團隊的使用權被停用時，內容區只顯示這段說明：不是登入失效、也不是已退出
 * 團隊，所以不登出、不自動切換；由使用者自己切換或重新確認權限。
 */
export function DisabledWorkspaceNotice({
  onSwitchWorkspace,
  onRecheck,
}: DisabledWorkspaceNoticeProps) {
  const { t } = useTranslation('web')
  return (
    <div data-testid="disabled-workspace-notice">
      <EmptyState
        icon={<UserX />}
        headingLevel={1}
        title={t('team.disabledWorkspaceTitle')}
        description={t('team.disabledWorkspaceBody')}
        action={
          <div className="flex flex-wrap justify-center gap-[var(--gap-sm)]">
            <Button variant="primary" onClick={onSwitchWorkspace}>
              {t('team.disabledWorkspaceSwitchCta')}
            </Button>
            <Button variant="secondary" onClick={onRecheck}>
              {t('team.disabledWorkspaceRecheckCta')}
            </Button>
          </div>
        }
      />
    </div>
  )
}
